<template>
    <div class="app-footer" :class="footerClasses">
        <layout-contained>
            <div class="py-6">
                <span class="text-gray-100">
                    &copy; {{ new Date().getFullYear() }}
                    {{ $config.public.companyNameLong }}
                    <span class="hidden md:inline">
                        | <NuxtLink class="hover:underline" to="/">Home</NuxtLink> |
                        <NuxtLink class="hover:underline" to="/contact">Contact</NuxtLink> |
                        <NuxtLink class="hover:underline" to="/privacy">Privacy</NuxtLink> |
                        <NuxtLink class="hover:underline" to="/cookies">Cookies</NuxtLink>
                    </span>
                </span>
            </div>
        </layout-contained>
    </div>
</template>

<script>
export default {
    name: 'AppFooter',
    props: {
        color: {
            required: false,
            type: String,
            default: 'bg-zinc-900',
        },
    },
    computed: {
        footerClasses() {
            const cls = {};
            cls[this.color] = true;
            return cls;
        },
    },
};
</script>
